( function( app ) {
  const SM_BREAKPOINT = 640;

  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '[data-component="video-gallery"]' ).forEach( ( section ) => {
        COMPONENT.initGallery( section );
      } );
    },

    initGallery: function( section ) {
      const grid = section.querySelector( '.video-gallery__grid' );
      const filtersWrap = section.querySelector( '.video-gallery__filters' );
      const viewMoreWrap = section.querySelector( '.video-gallery__more-wrap' );
      const viewMoreBtn = viewMoreWrap ? viewMoreWrap.querySelector( '.video-gallery__view-more' ) : null;

      if ( !grid ) return;

      const perPage = window.innerWidth < SM_BREAKPOINT ? 3 : 6;
      const total = parseInt( section.dataset.total ) || 0;

      // On mobile: trim server-rendered items to perPage
      const initialItems = [...grid.querySelectorAll( '.video-gallery__item' )];
      if ( initialItems.length > perPage ) {
        initialItems.slice( perPage ).forEach( ( el ) => el.remove() );
      }

      const state = {
        category: 'all',
        offset: Math.min( initialItems.length, perPage ),
        perPage,
        loading: false,
      };

      if ( viewMoreWrap && total > 6 ) {
        viewMoreWrap.hidden = false;
      }

      async function fetchVideos( append ) {
        if ( state.loading ) return;
        state.loading = true;
        setLoadingState( true );

        const body = new URLSearchParams( {
          action: 'filter_videos',
          nonce: section.dataset.nonce,
          category: state.category,
          offset: state.offset,
          per_page: state.perPage,
        } );

        try {
          const res = await fetch( siteInfo.ajax_url, {method: 'POST', body} );
          const json = await res.json();

          if ( json.success ) {
            const {html, loaded, has_more: hasMore} = json.data;

            if ( append ) {
              grid.insertAdjacentHTML( 'beforeend', html );
            } else {
              grid.innerHTML = html;
            }

            state.offset = loaded;

            if ( viewMoreWrap ) {
              viewMoreWrap.hidden = !hasMore || json.data.total <= 6;
            }
          }
        } catch ( e ) {
          // fail silently — existing items remain
        }

        state.loading = false;
        setLoadingState( false );
      }

      function setLoadingState( isLoading ) {
        [filtersWrap, viewMoreWrap].forEach( ( el ) => {
          if ( !el ) return;
          el.classList.toggle( 'pointer-events-none', isLoading );
          el.classList.toggle( 'opacity-50', isLoading );
        } );
      }

      // Filter buttons
      section.querySelectorAll( '[data-filter]' ).forEach( ( btn ) => {
        btn.addEventListener( 'click', () => {
          if ( state.loading ) return;

          const filter = btn.dataset.filter;
          if ( filter === state.category ) return;

          section.querySelectorAll( '[data-filter]' ).forEach( ( b ) => {
            b.classList.remove( 'is-active' );
            b.setAttribute( 'aria-pressed', 'false' );
          } );
          btn.classList.add( 'is-active' );
          btn.setAttribute( 'aria-pressed', 'true' );

          state.category = filter;
          state.offset = 0;
          fetchVideos( false );
        } );
      } );

      // View more
      if ( viewMoreBtn ) {
        viewMoreBtn.addEventListener( 'click', () => {
          fetchVideos( true );
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'video-gallery', COMPONENT );
} )( app );
